import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo} from 'react'
import {useLocation} from 'react-use'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import {withReportTable} from 'views/Workspace/Examination/renderReportTable'
import {renderIfElse} from "../../../Shared";
import {RiCheckFill, RiCloseFill} from "react-icons/ri";
import {useRouteSearchParam} from "../../../../envs/_current/history";
import TooltipApp from "../../../../components/TooltipApp";
import {course_getAttendanceTrackingSheetReport_Api} from "../../../../apis";
import {CourseClassStudentAttendanceSheetReportFilter} from "../components/filters/CourseClassStudentAttendanceSheetReportFilter";

const headers = [
    'lesson',
    'attend_count',
    'ea_count',
    'ua_count',
]

const schemas = [
    {
        name: 'title',
        value_path: 'title',
        className: 'font-medium text-color-000 whitespace-no-wrap',
    },
    {
        name: 'attend_count',
        value_path: 'attend_count',
        className: 'text-color-100',
        render: (value) => (
            renderIfElse(
                value >= 1,
                <RiCheckFill className="text-green-500"/>,
                <span/>
            )
        ),
    },
    {
        name: 'excused_absence_count',
        value_path: 'excused_absence_count',
        className: 'text-color-100',
        render: (value, data) => {
            return (
                renderIfElse(
                    value >= 1,
                    <TooltipApp title={data.absent_reason}>
                        <RiCheckFill className="text-red-500 cursor-pointer"/>
                    </TooltipApp>,
                    <span/>
                )
            )
        },
    },
    {
        name: 'unexcused_absence_count',
        value_path: 'unexcused_absence_count',
        className: 'text-color-100 w-16',
        render: (value) => (
            renderIfElse(
                value >= 1,
                <RiCloseFill className="text-red-500"/>,
                <span/>
            )
        ),
    },
]


const CourseClassStudentAttendanceSheetReport = ({
                                                     owner_id,
                                                     owner_type,
                                                     filter_actions = {
                                                         sortBy: 'sort-by',
                                                         keyword: 'keyword',
                                                         course_id: 'course-id',
                                                         student_id: 'student-id',
                                                         subject_id: 'subject-id',
                                                         course_class_id: 'class-id',
                                                     },
                                                 }) => {
    const t = useTranslate()

    const location = useLocation()

    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const course_id = useRouteSearchParam(filter_actions.course_id)

    const student_id = useRouteSearchParam(filter_actions.student_id)

    const subject_id = useRouteSearchParam(filter_actions.subject_id)

    const course_class_id = useRouteSearchParam(filter_actions.course_class_id)

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, location.state]
    )

    const [pager_widget, {widget_header}] = usePaginationHelper({
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onSortChange(sortBy)
            onFilterChange({
                course_id,
                student_id,
                course_class_id,
                subject_id
            })
        },
        pagerInfo: {
            query: bindQueryParams([
                {
                    id: course_class_id,
                },
                {
                    student_id,
                },
                {
                    subject_id,
                },
            ]),
            PaginationMeta: NullAsDefault,
            apiInfo: course_getAttendanceTrackingSheetReport_Api,
            ...withReportTable(headers, schemas),
        },
        withKey: createPagerKey(refresh_deps),
        dependencies: [owner_id, owner_type],
        filter_params: {
            owner_id,
            owner_type,
            course_id,
            student_id,
            subject_id,
            course_class_id,
        },
        renderSortBy: NullAsDefault,
        SortByWidget: NullAsDefault,
        renderSearchBar: NullAsDefault,
        // isToggleDefault: true,
        query_params: filter_actions,
        AdvancedFilter: CourseClassStudentAttendanceSheetReportFilter,
    })
    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-col flex-1">
                <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                    {t('report')}
                </h2>
                <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
            </div>
            <div className="p-4 border border-color-50 background shadow-md rounded-xl">
                <div className="flex flex-col gap-6">
                    <div className="text-center font-bold text-lg text-gray-700 uppercase tracking-widest mb-4">
                        {t('detail attendance sheet by student')}
                    </div>
                    {student_id ? pager_widget : widget_header}
                </div>
            </div>
        </div>
    )
}

export default compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(CourseClassStudentAttendanceSheetReport)
